/*
  Copyright (C) SohanIT Inc & JobsHorn. All rights reserved.
  This document contains material and information that is confidential and proprietary to SohanIT Inc & JobsHorn.
  Use and reproduction of this document electronically, copying, regenerating, reengineering, printing, decrypted,
  dissembled, decompiled, reverse-engineered or used to create derivative works or in any form are prohibited and
  governed by U.S. Copyright law. To use, written permission should be obtained from SohanIT Inc & JobsHorn.
*/
import React from 'react';
import { styled } from '@mui/system';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import colors from '../../vars.module.scss';
import { useTheme } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';

const BreadcrumbsContainer = styled(Breadcrumbs)({
  backgroundColor: '#ffffff', // Fallback color
  paddingBottom: 8,
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
});

const BreadcrumbLink = styled(Link)({
  color: colors?.primaryColor,
  textDecoration: 'none',
  fontWeight: 500,
  '&:hover': {
    textDecoration: 'underline',
  },
});

const BreadcrumbText = styled(Typography)({
  color: '#000000', // Text primary color fallback
});

const SeparatorIcon = styled(NavigateNextIcon)({
  color: '#757575', // Action active color fallback
});

/*
  Business Need: This component provides a customizable breadcrumbs.

  Program Functionality:
  - Breadcrumbs of the application 

  Potential Impact if Updated:
  - Breadcrumbs of the application will break

  Developer: Madhan
  Date: 27/01/2025
*/

function CustomBreadcrumbs({ breadcrumbs = [], bgColor = 'white' }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  const validItems = breadcrumbs.filter(item => item.text);
  return (
    <BreadcrumbsContainer
      maxItems={isMobile ? 3 : breadcrumbs.length}
      sx={{ backgroundColor: bgColor }}
      separator={<SeparatorIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {validItems.map((breadcrumb, index) => (
        <span key={index}>
          {breadcrumb.link ? (
            <BreadcrumbLink href={breadcrumb.link}>{breadcrumb.text}</BreadcrumbLink>
          ) : (
            <BreadcrumbText>{breadcrumb.text}</BreadcrumbText>
          )}
        </span>
      ))}
    </BreadcrumbsContainer>
  );
}

export default CustomBreadcrumbs;
